import { Helmet } from "react-helmet-async";

const SITE = "https://sportaraapp.com";

interface SeoHeadProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: "website" | "article";
  noindex?: boolean;
  jsonLd?: object | object[];
}

/**
 * Per-route head tags: unique title, description, self-referencing canonical,
 * absolute og:* + twitter:* tags, and optional JSON-LD.
 */
export function SeoHead({
  title,
  description,
  path,
  image = `${SITE}/og-image.png`,
  type = "website",
  noindex = false,
  jsonLd,
}: SeoHeadProps) {
  const url = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;
  const absImage = image.startsWith("http") ? image : `${SITE}${image}`;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Sportara" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />

      {ldArray.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
